<template>
  <div class="select-day-presentation2-title">
    <div
      class="select-day-presentation2-title__date"
      data-at-devlivery-date
    >
      {{ presentationDate }}
    </div>
    <div class="select-day-presentation2-title__separator">
      •
    </div>
    <div
      class="select-day-presentation2-title__time"
      data-at-devlivery-time
    >
      {{ presentationTime }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'SelectDayPresentation2',

  props: {
    params: {
      type: Object,
      required: true,
    },
  },

  computed: {
    presentationDate () {
      return this.$date(this.params.date).format('D MMM, dd')
    },

    presentationTime () {
      return `${this.params.timeFrom}-${this.params.timeTo}`
    },
  },
}
</script>

<style lang="scss">
$prefix: 'select-day-presentation2-title';

.#{$prefix} {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;

  @include typography('b1', 'medium');
}

.#{$prefix}__date {

}

.#{$prefix}__time {

}

.#{$prefix}__separator {
  color: rgb(203, 203, 203);
  margin: 0 0.06rem;
}
</style>
